import { accordionDetailsClasses as t } from "@mui/material";
import { styled as r } from "./styled2.mjs";
import i from "./AccordionDetails.mjs";
const a = r(i)`
	&.${t.root} {
		padding: ${({ theme: o }) => o.spacing(1.5)};
		color: ${({ theme: o }) => o.palette.text.secondary};
	}
`;
export {
  a as AccordionDetails
};
//# sourceMappingURL=styles75.mjs.map
